/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payoutKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type AdminPayoutCascadeServiceDeleteCascadeParams,
    type AdminPayoutCascadeServiceDeleteGroupParams,
    type AdminPayoutCascadeServiceDeleteTemplateParams,
    type AdminPayoutCascadeServiceGetCascadeParams,
    type AdminPayoutCascadeServiceGetGroupParams,
    type AdminPayoutCascadeServiceGetTemplateParams,
    type AdminPayoutCascadeServiceListCascadesParams,
    type AdminPayoutCascadeServiceListGroupsParams,
    type AdminPayoutCascadeServiceListTemplatesParams,
    type GoogleRpcStatus,
    type PayoutAdminCascadeV1CreateCascadeRequest,
    type PayoutAdminCascadeV1CreateCascadeResponse,
    type PayoutAdminCascadeV1CreateGroupRequest,
    type PayoutAdminCascadeV1CreateGroupResponse,
    type PayoutAdminCascadeV1CreateTemplateRequest,
    type PayoutAdminCascadeV1CreateTemplateResponse,
    type PayoutAdminCascadeV1DeleteCascadeResponse,
    type PayoutAdminCascadeV1DeleteGroupResponse,
    type PayoutAdminCascadeV1DeleteTemplateResponse,
    type PayoutAdminCascadeV1GetCascadeResponse,
    type PayoutAdminCascadeV1GetGroupResponse,
    type PayoutAdminCascadeV1GetTemplateResponse,
    type PayoutAdminCascadeV1ListCascadesResponse,
    type PayoutAdminCascadeV1ListGroupsResponse,
    type PayoutAdminCascadeV1ListTemplatesResponse,
    type PayoutAdminCascadeV1UpdateCascadeRequest,
    type PayoutAdminCascadeV1UpdateCascadeResponse,
    type PayoutAdminCascadeV1UpdateCascadeV2Request,
    type PayoutAdminCascadeV1UpdateCascadeV2Response,
    type PayoutAdminCascadeV1UpdateGroupRequest,
    type PayoutAdminCascadeV1UpdateGroupResponse,
    type PayoutAdminCascadeV1UpdateTemplateRequest,
    type PayoutAdminCascadeV1UpdateTemplateResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') {
            continue;
        }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getAdminPayoutCascadeServiceDeleteCascadeUrl = (params?: AdminPayoutCascadeServiceDeleteCascadeParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascade?${stringifiedParams}` : '/v1/cascade';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceDeleteCascade = async (
    params?: AdminPayoutCascadeServiceDeleteCascadeParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1DeleteCascadeResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1DeleteCascadeResponse>(
        getAdminPayoutCascadeServiceDeleteCascadeUrl(params),
        {
            ...options,
            method: 'DELETE',
        },
    );
};

export const getAdminPayoutCascadeServiceDeleteCascadeQueryKey = (
    params?: AdminPayoutCascadeServiceDeleteCascadeParams,
) => {
    return ['DELETE', '/v1/cascade', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceDeleteCascadeQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteCascadeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceDeleteCascadeQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>> = ({ signal }) =>
        adminPayoutCascadeServiceDeleteCascade(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceDeleteCascadeQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>
>;
export type AdminPayoutCascadeServiceDeleteCascadeQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceDeleteCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceDeleteCascadeParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceDeleteCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteCascadeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceDeleteCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteCascadeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceDeleteCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteCascadeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceDeleteCascadeQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceGetCascadeUrl = (params?: AdminPayoutCascadeServiceGetCascadeParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascade?${stringifiedParams}` : '/v1/cascade';
};

/**
 * @summary Requires cascades.read.
 */
export const adminPayoutCascadeServiceGetCascade = async (
    params?: AdminPayoutCascadeServiceGetCascadeParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1GetCascadeResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1GetCascadeResponse>(getAdminPayoutCascadeServiceGetCascadeUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutCascadeServiceGetCascadeQueryKey = (params?: AdminPayoutCascadeServiceGetCascadeParams) => {
    return ['/v1/cascade', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceGetCascadeQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetCascadeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceGetCascadeQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>> = ({ signal }) =>
        adminPayoutCascadeServiceGetCascade(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceGetCascadeQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>
>;
export type AdminPayoutCascadeServiceGetCascadeQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceGetCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceGetCascadeParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceGetCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetCascadeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceGetCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetCascadeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.read.
 */

export function useAdminPayoutCascadeServiceGetCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetCascadeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceGetCascadeQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceUpdateCascadeUrl = () => {
    return '/v1/cascade';
};

/**
 * @deprecated
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceUpdateCascade = async (
    payoutAdminCascadeV1UpdateCascadeRequest: PayoutAdminCascadeV1UpdateCascadeRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1UpdateCascadeResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1UpdateCascadeResponse>(getAdminPayoutCascadeServiceUpdateCascadeUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminCascadeV1UpdateCascadeRequest),
    });
};

export const getAdminPayoutCascadeServiceUpdateCascadeQueryKey = (
    payoutAdminCascadeV1UpdateCascadeRequest?: BodyType<PayoutAdminCascadeV1UpdateCascadeRequest>,
) => {
    return ['PUT', '/v1/cascade', payoutAdminCascadeV1UpdateCascadeRequest] as const;
};

export const getAdminPayoutCascadeServiceUpdateCascadeQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeRequest: BodyType<PayoutAdminCascadeV1UpdateCascadeRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutCascadeServiceUpdateCascadeQueryKey(payoutAdminCascadeV1UpdateCascadeRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>> = ({ signal }) =>
        adminPayoutCascadeServiceUpdateCascade(payoutAdminCascadeV1UpdateCascadeRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceUpdateCascadeQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>
>;
export type AdminPayoutCascadeServiceUpdateCascadeQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceUpdateCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeRequest: BodyType<PayoutAdminCascadeV1UpdateCascadeRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceUpdateCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeRequest: BodyType<PayoutAdminCascadeV1UpdateCascadeRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceUpdateCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeRequest: BodyType<PayoutAdminCascadeV1UpdateCascadeRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceUpdateCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeRequest: BodyType<PayoutAdminCascadeV1UpdateCascadeRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceUpdateCascadeQueryOptions(
        payoutAdminCascadeV1UpdateCascadeRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceListCascadesUrl = (params?: AdminPayoutCascadeServiceListCascadesParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascades?${stringifiedParams}` : '/v1/cascades';
};

/**
 * @summary Cascades CRUD
Requires cascades.read.
 */
export const adminPayoutCascadeServiceListCascades = async (
    params?: AdminPayoutCascadeServiceListCascadesParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1ListCascadesResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1ListCascadesResponse>(
        getAdminPayoutCascadeServiceListCascadesUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutCascadeServiceListCascadesQueryKey = (
    params?: AdminPayoutCascadeServiceListCascadesParams,
) => {
    return ['/v1/cascades', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceListCascadesQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListCascadesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceListCascadesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>> = ({ signal }) =>
        adminPayoutCascadeServiceListCascades(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceListCascadesQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>
>;
export type AdminPayoutCascadeServiceListCascadesQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceListCascades<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceListCascadesParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceListCascades<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListCascadesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceListCascades<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListCascadesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Cascades CRUD
Requires cascades.read.
 */

export function useAdminPayoutCascadeServiceListCascades<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListCascadesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListCascades>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceListCascadesQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceCreateCascadeUrl = () => {
    return '/v1/cascades';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceCreateCascade = async (
    payoutAdminCascadeV1CreateCascadeRequest: PayoutAdminCascadeV1CreateCascadeRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1CreateCascadeResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1CreateCascadeResponse>(getAdminPayoutCascadeServiceCreateCascadeUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminCascadeV1CreateCascadeRequest),
    });
};

export const getAdminPayoutCascadeServiceCreateCascadeQueryKey = (
    payoutAdminCascadeV1CreateCascadeRequest?: BodyType<PayoutAdminCascadeV1CreateCascadeRequest>,
) => {
    return ['POST', '/v1/cascades', payoutAdminCascadeV1CreateCascadeRequest] as const;
};

export const getAdminPayoutCascadeServiceCreateCascadeQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateCascadeRequest: BodyType<PayoutAdminCascadeV1CreateCascadeRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutCascadeServiceCreateCascadeQueryKey(payoutAdminCascadeV1CreateCascadeRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>> = ({ signal }) =>
        adminPayoutCascadeServiceCreateCascade(payoutAdminCascadeV1CreateCascadeRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceCreateCascadeQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>
>;
export type AdminPayoutCascadeServiceCreateCascadeQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceCreateCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateCascadeRequest: BodyType<PayoutAdminCascadeV1CreateCascadeRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceCreateCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateCascadeRequest: BodyType<PayoutAdminCascadeV1CreateCascadeRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceCreateCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateCascadeRequest: BodyType<PayoutAdminCascadeV1CreateCascadeRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceCreateCascade<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateCascadeRequest: BodyType<PayoutAdminCascadeV1CreateCascadeRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateCascade>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceCreateCascadeQueryOptions(
        payoutAdminCascadeV1CreateCascadeRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceDeleteGroupUrl = (params?: AdminPayoutCascadeServiceDeleteGroupParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascades/group?${stringifiedParams}` : '/v1/cascades/group';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceDeleteGroup = async (
    params?: AdminPayoutCascadeServiceDeleteGroupParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1DeleteGroupResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1DeleteGroupResponse>(
        getAdminPayoutCascadeServiceDeleteGroupUrl(params),
        {
            ...options,
            method: 'DELETE',
        },
    );
};

export const getAdminPayoutCascadeServiceDeleteGroupQueryKey = (
    params?: AdminPayoutCascadeServiceDeleteGroupParams,
) => {
    return ['DELETE', '/v1/cascades/group', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceDeleteGroupQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteGroupParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceDeleteGroupQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>> = ({ signal }) =>
        adminPayoutCascadeServiceDeleteGroup(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceDeleteGroupQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>
>;
export type AdminPayoutCascadeServiceDeleteGroupQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceDeleteGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceDeleteGroupParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceDeleteGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteGroupParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceDeleteGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteGroupParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceDeleteGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteGroupParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceDeleteGroupQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceGetGroupUrl = (params?: AdminPayoutCascadeServiceGetGroupParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascades/group?${stringifiedParams}` : '/v1/cascades/group';
};

/**
 * @summary Requires cascades.read.
 */
export const adminPayoutCascadeServiceGetGroup = async (
    params?: AdminPayoutCascadeServiceGetGroupParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1GetGroupResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1GetGroupResponse>(getAdminPayoutCascadeServiceGetGroupUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutCascadeServiceGetGroupQueryKey = (params?: AdminPayoutCascadeServiceGetGroupParams) => {
    return ['/v1/cascades/group', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceGetGroupQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetGroupParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceGetGroupQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>> = ({ signal }) =>
        adminPayoutCascadeServiceGetGroup(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceGetGroupQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>
>;
export type AdminPayoutCascadeServiceGetGroupQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceGetGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceGetGroupParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceGetGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetGroupParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceGetGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetGroupParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.read.
 */

export function useAdminPayoutCascadeServiceGetGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetGroupParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetGroup>>, TError, TData>>;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceGetGroupQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceUpdateGroupUrl = () => {
    return '/v1/cascades/group';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceUpdateGroup = async (
    payoutAdminCascadeV1UpdateGroupRequest: PayoutAdminCascadeV1UpdateGroupRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1UpdateGroupResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1UpdateGroupResponse>(getAdminPayoutCascadeServiceUpdateGroupUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminCascadeV1UpdateGroupRequest),
    });
};

export const getAdminPayoutCascadeServiceUpdateGroupQueryKey = (
    payoutAdminCascadeV1UpdateGroupRequest?: BodyType<PayoutAdminCascadeV1UpdateGroupRequest>,
) => {
    return ['PUT', '/v1/cascades/group', payoutAdminCascadeV1UpdateGroupRequest] as const;
};

export const getAdminPayoutCascadeServiceUpdateGroupQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateGroupRequest: BodyType<PayoutAdminCascadeV1UpdateGroupRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutCascadeServiceUpdateGroupQueryKey(payoutAdminCascadeV1UpdateGroupRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>> = ({ signal }) =>
        adminPayoutCascadeServiceUpdateGroup(payoutAdminCascadeV1UpdateGroupRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceUpdateGroupQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>
>;
export type AdminPayoutCascadeServiceUpdateGroupQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceUpdateGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateGroupRequest: BodyType<PayoutAdminCascadeV1UpdateGroupRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceUpdateGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateGroupRequest: BodyType<PayoutAdminCascadeV1UpdateGroupRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceUpdateGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateGroupRequest: BodyType<PayoutAdminCascadeV1UpdateGroupRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceUpdateGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateGroupRequest: BodyType<PayoutAdminCascadeV1UpdateGroupRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceUpdateGroupQueryOptions(
        payoutAdminCascadeV1UpdateGroupRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceListGroupsUrl = (params?: AdminPayoutCascadeServiceListGroupsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascades/groups?${stringifiedParams}` : '/v1/cascades/groups';
};

/**
 * @summary Groups CRUD
Requires cascades.read.
 */
export const adminPayoutCascadeServiceListGroups = async (
    params?: AdminPayoutCascadeServiceListGroupsParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1ListGroupsResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1ListGroupsResponse>(getAdminPayoutCascadeServiceListGroupsUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayoutCascadeServiceListGroupsQueryKey = (params?: AdminPayoutCascadeServiceListGroupsParams) => {
    return ['/v1/cascades/groups', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceListGroupsQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListGroupsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceListGroupsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>> = ({ signal }) =>
        adminPayoutCascadeServiceListGroups(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceListGroupsQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>
>;
export type AdminPayoutCascadeServiceListGroupsQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceListGroups<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceListGroupsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceListGroups<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListGroupsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceListGroups<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListGroupsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Groups CRUD
Requires cascades.read.
 */

export function useAdminPayoutCascadeServiceListGroups<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListGroupsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListGroups>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceListGroupsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceCreateGroupUrl = () => {
    return '/v1/cascades/groups';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceCreateGroup = async (
    payoutAdminCascadeV1CreateGroupRequest: PayoutAdminCascadeV1CreateGroupRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1CreateGroupResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1CreateGroupResponse>(getAdminPayoutCascadeServiceCreateGroupUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payoutAdminCascadeV1CreateGroupRequest),
    });
};

export const getAdminPayoutCascadeServiceCreateGroupQueryKey = (
    payoutAdminCascadeV1CreateGroupRequest?: BodyType<PayoutAdminCascadeV1CreateGroupRequest>,
) => {
    return ['POST', '/v1/cascades/groups', payoutAdminCascadeV1CreateGroupRequest] as const;
};

export const getAdminPayoutCascadeServiceCreateGroupQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateGroupRequest: BodyType<PayoutAdminCascadeV1CreateGroupRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutCascadeServiceCreateGroupQueryKey(payoutAdminCascadeV1CreateGroupRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>> = ({ signal }) =>
        adminPayoutCascadeServiceCreateGroup(payoutAdminCascadeV1CreateGroupRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceCreateGroupQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>
>;
export type AdminPayoutCascadeServiceCreateGroupQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceCreateGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateGroupRequest: BodyType<PayoutAdminCascadeV1CreateGroupRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceCreateGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateGroupRequest: BodyType<PayoutAdminCascadeV1CreateGroupRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceCreateGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateGroupRequest: BodyType<PayoutAdminCascadeV1CreateGroupRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceCreateGroup<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateGroupRequest: BodyType<PayoutAdminCascadeV1CreateGroupRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateGroup>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceCreateGroupQueryOptions(
        payoutAdminCascadeV1CreateGroupRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceDeleteTemplateUrl = (
    params?: AdminPayoutCascadeServiceDeleteTemplateParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascades/template?${stringifiedParams}` : '/v1/cascades/template';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceDeleteTemplate = async (
    params?: AdminPayoutCascadeServiceDeleteTemplateParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1DeleteTemplateResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1DeleteTemplateResponse>(
        getAdminPayoutCascadeServiceDeleteTemplateUrl(params),
        {
            ...options,
            method: 'DELETE',
        },
    );
};

export const getAdminPayoutCascadeServiceDeleteTemplateQueryKey = (
    params?: AdminPayoutCascadeServiceDeleteTemplateParams,
) => {
    return ['DELETE', '/v1/cascades/template', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceDeleteTemplateQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteTemplateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceDeleteTemplateQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>> = ({ signal }) =>
        adminPayoutCascadeServiceDeleteTemplate(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceDeleteTemplateQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>
>;
export type AdminPayoutCascadeServiceDeleteTemplateQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceDeleteTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceDeleteTemplateParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceDeleteTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteTemplateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceDeleteTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteTemplateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceDeleteTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceDeleteTemplateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceDeleteTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceDeleteTemplateQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceGetTemplateUrl = (params?: AdminPayoutCascadeServiceGetTemplateParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascades/template?${stringifiedParams}` : '/v1/cascades/template';
};

/**
 * @summary Requires cascades.read.
 */
export const adminPayoutCascadeServiceGetTemplate = async (
    params?: AdminPayoutCascadeServiceGetTemplateParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1GetTemplateResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1GetTemplateResponse>(
        getAdminPayoutCascadeServiceGetTemplateUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutCascadeServiceGetTemplateQueryKey = (
    params?: AdminPayoutCascadeServiceGetTemplateParams,
) => {
    return ['/v1/cascades/template', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceGetTemplateQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetTemplateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceGetTemplateQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>> = ({ signal }) =>
        adminPayoutCascadeServiceGetTemplate(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceGetTemplateQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>
>;
export type AdminPayoutCascadeServiceGetTemplateQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceGetTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceGetTemplateParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceGetTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetTemplateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceGetTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetTemplateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.read.
 */

export function useAdminPayoutCascadeServiceGetTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceGetTemplateParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceGetTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceGetTemplateQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceUpdateTemplateUrl = () => {
    return '/v1/cascades/template';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceUpdateTemplate = async (
    payoutAdminCascadeV1UpdateTemplateRequest: PayoutAdminCascadeV1UpdateTemplateRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1UpdateTemplateResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1UpdateTemplateResponse>(
        getAdminPayoutCascadeServiceUpdateTemplateUrl(),
        {
            ...options,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payoutAdminCascadeV1UpdateTemplateRequest),
        },
    );
};

export const getAdminPayoutCascadeServiceUpdateTemplateQueryKey = (
    payoutAdminCascadeV1UpdateTemplateRequest?: BodyType<PayoutAdminCascadeV1UpdateTemplateRequest>,
) => {
    return ['PUT', '/v1/cascades/template', payoutAdminCascadeV1UpdateTemplateRequest] as const;
};

export const getAdminPayoutCascadeServiceUpdateTemplateQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateTemplateRequest: BodyType<PayoutAdminCascadeV1UpdateTemplateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutCascadeServiceUpdateTemplateQueryKey(payoutAdminCascadeV1UpdateTemplateRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>> = ({ signal }) =>
        adminPayoutCascadeServiceUpdateTemplate(payoutAdminCascadeV1UpdateTemplateRequest, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceUpdateTemplateQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>
>;
export type AdminPayoutCascadeServiceUpdateTemplateQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceUpdateTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateTemplateRequest: BodyType<PayoutAdminCascadeV1UpdateTemplateRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceUpdateTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateTemplateRequest: BodyType<PayoutAdminCascadeV1UpdateTemplateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceUpdateTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateTemplateRequest: BodyType<PayoutAdminCascadeV1UpdateTemplateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceUpdateTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateTemplateRequest: BodyType<PayoutAdminCascadeV1UpdateTemplateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceUpdateTemplateQueryOptions(
        payoutAdminCascadeV1UpdateTemplateRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceListTemplatesUrl = (params?: AdminPayoutCascadeServiceListTemplatesParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/cascades/templates?${stringifiedParams}` : '/v1/cascades/templates';
};

/**
 * @summary Templates CRUD
Requires cascades.read.
 */
export const adminPayoutCascadeServiceListTemplates = async (
    params?: AdminPayoutCascadeServiceListTemplatesParams,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1ListTemplatesResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1ListTemplatesResponse>(
        getAdminPayoutCascadeServiceListTemplatesUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayoutCascadeServiceListTemplatesQueryKey = (
    params?: AdminPayoutCascadeServiceListTemplatesParams,
) => {
    return ['/v1/cascades/templates', ...(params ? [params] : [])] as const;
};

export const getAdminPayoutCascadeServiceListTemplatesQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListTemplatesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayoutCascadeServiceListTemplatesQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>> = ({ signal }) =>
        adminPayoutCascadeServiceListTemplates(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceListTemplatesQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>
>;
export type AdminPayoutCascadeServiceListTemplatesQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceListTemplates<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayoutCascadeServiceListTemplatesParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceListTemplates<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListTemplatesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceListTemplates<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListTemplatesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Templates CRUD
Requires cascades.read.
 */

export function useAdminPayoutCascadeServiceListTemplates<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayoutCascadeServiceListTemplatesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceListTemplates>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceListTemplatesQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceCreateTemplateUrl = () => {
    return '/v1/cascades/templates';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceCreateTemplate = async (
    payoutAdminCascadeV1CreateTemplateRequest: PayoutAdminCascadeV1CreateTemplateRequest,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1CreateTemplateResponse> => {
    return payoutKyMutator<PayoutAdminCascadeV1CreateTemplateResponse>(
        getAdminPayoutCascadeServiceCreateTemplateUrl(),
        {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payoutAdminCascadeV1CreateTemplateRequest),
        },
    );
};

export const getAdminPayoutCascadeServiceCreateTemplateQueryKey = (
    payoutAdminCascadeV1CreateTemplateRequest?: BodyType<PayoutAdminCascadeV1CreateTemplateRequest>,
) => {
    return ['POST', '/v1/cascades/templates', payoutAdminCascadeV1CreateTemplateRequest] as const;
};

export const getAdminPayoutCascadeServiceCreateTemplateQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateTemplateRequest: BodyType<PayoutAdminCascadeV1CreateTemplateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutCascadeServiceCreateTemplateQueryKey(payoutAdminCascadeV1CreateTemplateRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>> = ({ signal }) =>
        adminPayoutCascadeServiceCreateTemplate(payoutAdminCascadeV1CreateTemplateRequest, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceCreateTemplateQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>
>;
export type AdminPayoutCascadeServiceCreateTemplateQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceCreateTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateTemplateRequest: BodyType<PayoutAdminCascadeV1CreateTemplateRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceCreateTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateTemplateRequest: BodyType<PayoutAdminCascadeV1CreateTemplateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceCreateTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateTemplateRequest: BodyType<PayoutAdminCascadeV1CreateTemplateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceCreateTemplate<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1CreateTemplateRequest: BodyType<PayoutAdminCascadeV1CreateTemplateRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceCreateTemplate>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceCreateTemplateQueryOptions(
        payoutAdminCascadeV1CreateTemplateRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayoutCascadeServiceUpdateCascadeV2Url = () => {
    return '/v2/cascade';
};

/**
 * @summary Requires cascades.manage.
 */
export const adminPayoutCascadeServiceUpdateCascadeV2 = async (
    payoutAdminCascadeV1UpdateCascadeV2Request: PayoutAdminCascadeV1UpdateCascadeV2Request,
    options?: Parameters<typeof payoutKyMutator>[1],
): Promise<PayoutAdminCascadeV1UpdateCascadeV2Response> => {
    return payoutKyMutator<PayoutAdminCascadeV1UpdateCascadeV2Response>(
        getAdminPayoutCascadeServiceUpdateCascadeV2Url(),
        {
            ...options,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payoutAdminCascadeV1UpdateCascadeV2Request),
        },
    );
};

export const getAdminPayoutCascadeServiceUpdateCascadeV2QueryKey = (
    payoutAdminCascadeV1UpdateCascadeV2Request?: BodyType<PayoutAdminCascadeV1UpdateCascadeV2Request>,
) => {
    return ['PUT', '/v2/cascade', payoutAdminCascadeV1UpdateCascadeV2Request] as const;
};

export const getAdminPayoutCascadeServiceUpdateCascadeV2QueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeV2Request: BodyType<PayoutAdminCascadeV1UpdateCascadeV2Request>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayoutCascadeServiceUpdateCascadeV2QueryKey(payoutAdminCascadeV1UpdateCascadeV2Request);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>> = ({ signal }) =>
        adminPayoutCascadeServiceUpdateCascadeV2(payoutAdminCascadeV1UpdateCascadeV2Request, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayoutCascadeServiceUpdateCascadeV2QueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>
>;
export type AdminPayoutCascadeServiceUpdateCascadeV2QueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayoutCascadeServiceUpdateCascadeV2<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeV2Request: BodyType<PayoutAdminCascadeV1UpdateCascadeV2Request>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceUpdateCascadeV2<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeV2Request: BodyType<PayoutAdminCascadeV1UpdateCascadeV2Request>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayoutCascadeServiceUpdateCascadeV2<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeV2Request: BodyType<PayoutAdminCascadeV1UpdateCascadeV2Request>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Requires cascades.manage.
 */

export function useAdminPayoutCascadeServiceUpdateCascadeV2<
    TData = Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payoutAdminCascadeV1UpdateCascadeV2Request: BodyType<PayoutAdminCascadeV1UpdateCascadeV2Request>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayoutCascadeServiceUpdateCascadeV2>>, TError, TData>
        >;
        request?: SecondParameter<typeof payoutKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayoutCascadeServiceUpdateCascadeV2QueryOptions(
        payoutAdminCascadeV1UpdateCascadeV2Request,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
